import type { SpinResponse } from "@slot/client-engine";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";

/**
 * Two clusters in one substep, at opposite corners: a column of four L2 down the left edge (each candy dropping into the
 * one below it: two L3) and a row of four H2 along the bottom right (each right candy sliding into its left neighbour:
 * two H3) pay 0.30 + 1.00 together and merge at once.
 */
export function mergeDouble(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-double", ...OFFLINE_ROUND })
    .baseSpin({
      board: [
        ["L2", "L1", "L3", "L4", "L1", "L3"],
        ["L2", "L3", "L1", "H1", "L4", "L1"],
        ["L2", "L4", "L3", "L2", "L1", "L4"],
        ["L2", "H1", "L4", "L1", "L3", "L2"],
        ["H3", "L1", "L2", "L4", "L1", "L3"],
        ["L1", "L4", "H2", "H2", "H2", "H2"],
      ],
      refill: [["H2", "L4"], [], [], ["H4"], [], ["L2"]],
    })
    .build();
}
